import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import AccountConfig from '../auth/AccountConfig';
import NavBtns from '../Buttons/NavBtns';
import useUser from '../Hooks/useUser';
import Logo from '../logo';
import { GiHamburgerMenu } from 'react-icons/gi';
import { AiOutlineClose } from 'react-icons/ai';

function Nav() {
    const userState = useUser();
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => setIsOpen(!isOpen);
    const closeMenu = () => setIsOpen(false);

    return (
        <nav className="fixed top-0 left-0 right-0 w-full bg-gradient-to-r from-violet-600 via-indigo-600 to-purple-700 shadow-xl z-[60] backdrop-blur-sm bg-opacity-95">
            <div className="flex items-center px-4 md:px-8 py-3">
                {/* Logo - Top Left Corner */}
                <div className='flex-shrink-0'>
                    <Logo isShow={isOpen} className='text-white' />
                </div>

                {/* Desktop Navigation - Centered in the middle of the page */}
                <div className='hidden md:flex items-center justify-center absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2'>
                    <ul className='flex gap-8 list-none items-center'>
                        <NavBtns title="Home" link="/" />
                        <NavBtns title="Exercícios" link="/grammar" badge="NEW" />
                        <NavBtns title="Meu Progresso" link="/progress" />
                    </ul>
                </div>

                {/* Desktop Profile Icon - Right */}
                <div className='hidden md:flex items-center flex-shrink-0 ml-auto'>
                    <AccountConfig />
                </div>

                {/* Mobile Menu Button */}
                <button
                    onClick={toggleMenu}
                    className='md:hidden p-2 rounded-lg hover:bg-white hover:bg-opacity-10 transition-colors text-white ml-auto mr-4 md:mr-8'
                    aria-label="Toggle menu"
                >
                    {isOpen ? (
                        <AiOutlineClose size={24} />
                    ) : (
                        <GiHamburgerMenu size={24} />
                    )}
                </button>
            </div>

            {/* Mobile Navigation */}
            {isOpen && (
                <div className='md:hidden bg-gradient-to-b from-violet-700 to-indigo-700 border-t border-white border-opacity-10'>
                    <ul className='flex flex-col list-none p-4 gap-1'>
                        <li>
                            <Link
                                to="/"
                                onClick={closeMenu}
                                className='block px-4 py-3 text-white font-medium hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors'
                            >
                                Home
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/grammar"
                                onClick={closeMenu}
                                className='block relative px-4 py-3 text-white font-medium hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors'
                            >
                                Exercícios
                                <span className='absolute -top-8 -right-2 px-2 py-0.5 text-xs font-bold bg-red-500 text-white rounded-full'>
                                    NEW
                                </span>
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/progress"
                                onClick={closeMenu}
                                className='block px-4 py-3 text-white font-medium hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors'
                            >
                                Meu Progresso
                            </Link>
                        </li>

                        <div className='border-t border-white border-opacity-10 my-2'></div>

                        {userState.userId ? (
                            <>
                                <li>
                                    <Link
                                        to="/deleteAccount"
                                        onClick={closeMenu}
                                        className='block px-4 py-3 text-white font-medium hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors'
                                    >
                                        Conta
                                    </Link>
                                </li>
                                <li>
                                    <button
                                        onClick={() => {
                                            userState.signOut();
                                            closeMenu();
                                        }}
                                        className='w-full text-left px-4 py-3 text-white font-medium hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors'
                                    >
                                        Sair
                                    </button>
                                </li>
                            </>
                        ) : (
                            <>
                                <li>
                                    <Link
                                        to="/login"
                                        onClick={closeMenu}
                                        className='block px-4 py-3 text-white font-medium hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors'
                                    >
                                        Entrar
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/signup"
                                        onClick={closeMenu}
                                        className='block px-4 py-3 text-white font-medium hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors'
                                    >
                                        Criar Conta
                                    </Link>
                                </li>
                            </>
                        )}
                    </ul>
                </div>
            )}
        </nav>
    )
}

export default Nav;
